
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"16","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"clip-path":"url(#clip0_605_10036)"}},[_c('path',{attrs:{"clip-rule":"evenodd","d":"M8 15.166A6.667 6.667 0 108 1.833a6.667 6.667 0 000 13.333zm2.471-9.138c.26.26.26.683 0 .943L8.943 8.5l1.528 1.528a.667.667 0 11-.942.943l-1.53-1.529-1.528 1.53a.667.667 0 01-.942-.944L7.057 8.5 5.53 6.97a.667.667 0 11.942-.943L8 7.557l1.529-1.529c.26-.26.682-.26.942 0z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_605_10036"}},[_c('path',{attrs:{"transform":"translate(0 .5)","d":"M0 0h16v16H0z"}})])])]);
        };
      

        module.exports = {
          
          render: render,
        };
      